/**
 * Entity-type icons for the type-ahead suggestion rows (issue 190).
 *
 * Keyed by the CANONICAL Family's URL segment — a platform vocabulary
 * (scripts/mrcs/canonical-families.json), not a per-system list — with a
 * default for any segment the map does not name: a user-authored Family, a
 * layer's own Family, or a canonical slot added after this file. The default
 * is deliberate rather than a gap, so a Family authored this afternoon gets a
 * sensible icon with nobody editing anything.
 */

import {
  Sparkles, Award, Shield, Users, Package, BookOpen, Languages, Skull,
  Sun, Book, Copy, Layers, FileText,
} from 'lucide-react';

const ICON_BY_SEGMENT = {
  spells: Sparkles,
  feats: Award,
  classes: Shield,
  races: Users,
  items: Package,
  skills: BookOpen,
  languages: Languages,
  monsters: Skull,
  deities: Sun,
  rulebooks: Book,
  templates: Copy,
  archetypes: Layers,
};

/** The lucide component for an entity_type (plural route segment). */
export default function entityTypeIcon(entityType) {
  return ICON_BY_SEGMENT[entityType] || FileText;
}
